import React, { useEffect, useReducer, useRef } from "react";
import authReducer from "./authReducer";
import authContext from "./authContext";
import { useNavigate } from 'react-router-dom';

import { getUser, authUser } from "../../api/user";

import {
    OBTENER_USUARIO,
    LOGIN_EXITOSO,
    LOGIN_ERROR,
    CERRAR_SESION,
    LIMPIAR_ERROR,
} from "./authActions";
import Swal from "sweetalert2";

const AuthState = props => {

    const initialState = {
        token: null,
        autenticado: false,
        usuario: null,
        mensaje: null,
        cargando: true
    };

    const [state, dispatch] = useReducer(authReducer, initialState);
    const userRef = useRef(state.usuario);

    const navigate = useNavigate();

    const usuarioAutenticado = async () => {
        const token = localStorage.getItem('token')

        try {
            if (token != undefined && token != null) {
                const respuesta = await getUser(token);

                dispatch({
                    type: OBTENER_USUARIO,
                    payload: respuesta.data.data
                });
            }
        } catch (err) {
            console.log("err", err);

            if (err.message === "Network Error") {
                dispatch({
                    type: LOGIN_ERROR,
                    payload: {
                        msg: 'Servidor fuera de Servicio. Compruebe conexion.'
                    }
                })
            }
        }
    }

    const iniciarSesion = async datos => {
        if (datos.userName.trim() !== '' && datos.password.trim() !== '') {
            try {
                const respuesta = await authUser(datos);

                dispatch({
                    type: LOGIN_EXITOSO,
                    payload: respuesta.data.data
                })

                localStorage.setItem('token', respuesta.data.data);
                return { autenticado: true };
            } catch (error) {
                console.log("error", error);

                if (error.message == 'Network Error') {
                    const alerta = {
                        msg: "El Servidor no se encuentra disponible",
                        categoria: 'alerta-error'
                    };

                    dispatch({
                        type: LOGIN_ERROR,
                        payload: alerta
                    });

                    return { autenticado: false, error: { response: { data: { message: alerta.msg } } } };
                } else {
                    const alerta = {
                        msg: error.response?.data?.message || error.message,
                        categoria: 'alerta-error'
                    };

                    dispatch({
                        type: LOGIN_ERROR,
                        payload: alerta
                    });
                }
                return { autenticado: false, error }
            }
        } else {
            const alerta = {
                msg: "Debe Ingresar un Usuario valido con su Contraseña",
                categoria: 'alerta-error'
            };

            dispatch({
                type: LOGIN_ERROR,
                payload: alerta
            });
        }
    }

    const cerrarSesion = async (showMessage = true) => {
        await localStorage.removeItem('token');
        showMessage && dispatch({
            type: CERRAR_SESION,
            payload: 'Se cerro sesion'
        })
    }

    const limpiarError = () => {
        dispatch({
            type: LIMPIAR_ERROR
        })
    }

    const checkIfAdmin = () => {
        if (state.usuario) {
            return state.usuario.userType?.some(ut => ut.typeName === "ADMIN");
        }
        return false;
    }

    const logout = () => {
        localStorage.removeItem("token");
        window.location.replace("/");
    };

    useEffect(() => {
        const syncLogout = (event) => {
            if (event.key === "token") {
                if (event.newValue === null) {
                    logout();
                } else {
                    window.location.replace("/");
                }
            }
        };

        window.addEventListener("storage", syncLogout);
        return () =>
            window.removeEventListener("storage", syncLogout);
    }, []);

    useEffect(() => {
        userRef.current = state.usuario;
    }, [state.usuario])

    useEffect(() => {
        usuarioAutenticado()
    }, []);

    return (
        <authContext.Provider
            value={{
                token: state.token,
                autenticado: state.autenticado,
                usuario: state.usuario,
                mensaje: state.mensaje,
                cargando: state.cargando,
                iniciarSesion,
                usuarioAutenticado,
                cerrarSesion,
                limpiarError,
                checkIfAdmin
            }}
        >
            {props.children}
        </authContext.Provider>
    )

}

export default AuthState;
